import React, {FC} from 'react';
import {IonSpinner} from '@ionic/react';

type IULoadingIndicatorProps = {
    style?: string;
}

const UILoadingIndicator: FC<IULoadingIndicatorProps> = ({style}) => {
  return (
    <div className="p-6 flex flex-col h-full items-center justify-center text-navy-primary">
      <IonSpinner className={style}/>
    </div>
  );
};

export default UILoadingIndicator;
